import React, { useEffect, useState } from "react";
import {graphql, Link, useStaticQuery} from "gatsby";

import logo from "../img/logo.svg";
import newLogo from "../img/agoric-system-logo.svg";

export default function Header({isDifferentLogo=false}) {
	const menuQuery = useStaticQuery(graphql`
		query {
			contentfulMenu(contentful_id: { eq: "sBkYGrpTWY0toYK1C3ZLo" }) {
				... MenuDetails
			}
		}
	`);
	const {contentfulMenu} = menuQuery;

	const [isNavCollapsed, setIsNavCollapsed] = useState(true);
	const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

	const [isShrunk, setShrunk] = useState(false);

	useEffect(() => {
		const handler = () => {
			setShrunk((isShrunk) => {
				if (!isShrunk && (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200)) {
					return true;
				}

				if (isShrunk && document.body.scrollTop < 100 && document.documentElement.scrollTop < 100) {
					return false;
				}

				return isShrunk;
			});
		};

		window.addEventListener("scroll", handler);
		return () => window.removeEventListener("scroll", handler);
	}, []);


	return (
		<header id='header' className={`${isShrunk ? 'scrolled' : ''}`}>
			<div className='heading'>
				<div className='row'>
					<div className='col-md-12'>
						<nav className='navbar navbar-expand-lg'>
							<a className='navbar-brand' href='/'>
								<img src={isDifferentLogo ? newLogo : logo} alt={"Agoric"} height={36} />
							</a>
							<button
								className={`navbar-toggler hamburger hamburger--collapse ${isNavCollapsed ? "collapsed" : "is-active"}`}
								type='button'
								data-bs-toggle='collapse'
								data-bs-target='#navbarSupportedContent'
								aria-controls='navbarSupportedContent'
								aria-label='Toggle navigation'
								aria-expanded='false'
								onClick={handleNavCollapse}
							>
								<span className='hamburger-box'>
									<span className='hamburger-inner' />
								</span>
							</button>
							<div className={`collapse navbar-collapse`} id='navbarSupportedContent'>
								<div id='navbar-nav' className='navbar-nav'>
									<ul id='menu-header-menu' className='menu'>
										{contentfulMenu.elements.map(function (menu, index) {
											return (
												<li key={index} className={menu.elements ? "menu-item has-submenu" : "menu-item"}>
													{!menu.elements ? (
														<Link to={menu.url}>{menu.title}</Link>
													) : (
														<div>
															{menu.title} <span />
															<span />
															<ul id='menu-individuals-submenu' className='submenu'>
																{menu.elements.map(function (submenu, i) {
																	return (
																		<li key={i} className='menu-item'>
																			{submenu.isExternal && (
																				<a target='_blank' rel='noreferrer' href={submenu.url}>
																					{submenu.title}
																				</a>
																			)}
																			{!submenu.isExternal && (
																				<Link to={'/'+submenu.url}>{submenu.title}</Link>
																			)}
																		</li>
																	);
																})}
															</ul>
														</div>
													)}
												</li>
											);
										})}
									</ul>
								</div>
							</div>
						</nav>
					</div>
				</div>
			</div>
		</header>
	);
}
